<template>
<div class="entrance_container" @click="gotoTemplateLib">
    <div class="layout">
      <div class="left">
        <svg-icon icon-class="cloud-template-brand"></svg-icon>
      </div>
      <div class="right">
        <div class="title">{{$t("模板库#!!!#src/pages/CloudHome/components/TemplateEntrance.vue_1")}}</div>
        <div class="desc">{{$t("选择模板快速新建#!!!#src/pages/CloudHome/components/TemplateEntrance.vue_1")}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "test_vue",
  props: [],
  emits: ["gotoTemplateLib"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    gotoTemplateLib() {
      this.$emit("gotoTemplateLib", ["WORD", "EXCEL", "PPT", "DOCUMENT"]);
    },
  },
};
</script>

<style lang="scss" scoped>
.entrance_container {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 220px;
  height: 58px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #efeff0;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    border: 1px solid #5c70ff;
  }

  .layout {
    display: flex;
    flex-direction: row;
    align-items: center;

    .left {
      margin: 0px 16px;
      width: 26px;
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 26px;
        height: 26px;
      }
    }

    .right {
      display: flex;
      flex-direction: column;

      .title {
        margin-bottom: 1px;
        line-height: 20px;
        font-weight: 500;
        font-size: 14px;
        color: #222329;
        letter-spacing: 0;
      }

      .desc {
        line-height: 17px;
        font-weight: 400;
        font-size: 12px;
        color: #646573;
      }
    }
  }
}
</style>
